import { axiosPrivate } from "./axios";

/**
 * Expense Sharing API
 */

export const expenseService = {
  /**
   * Get all employees (for expense form)
   */
  getEmployees: async () => {
    const response = await axiosPrivate.get("/api/expenses/employees");
    return response.data;
  },

  /**
   * Create a new expense
   */
  createExpense: async (expenseData) => {
    const response = await axiosPrivate.post("/api/expenses", expenseData);
    return response.data;
  },

  /**
   * Get all expenses (optional filter by paidBy)
   */
  getAllExpenses: async (paidBy = null) => {
    const url = paidBy ? `/api/expenses?paidBy=${paidBy}` : "/api/expenses";
    const response = await axiosPrivate.get(url);
    return response.data;
  },

  /**
   * Get expense by ID
   */
  getExpenseById: async (id) => {
    const response = await axiosPrivate.get(`/api/expenses/${id}`);
    return response.data;
  },

  /**
   * Get user's debts (money they owe and money owed to them)
   */
  getUserDebts: async () => {
    const response = await axiosPrivate.get("/api/expenses/debts");
    return response.data;
  },

  /**
   * Get user's payment history (confirmed debts)
   */
  getPaymentHistory: async () => {
    const response = await axiosPrivate.get("/api/expenses/history");
    return response.data;
  },

  /**
   * Claim payment (debtor marks as paid)
   */
  claimPayment: async (debtId) => {
    const response = await axiosPrivate.post(
      `/api/expenses/debts/${debtId}/claim`,
    );
    return response.data;
  },

  /**
   * Confirm payment (creditor accepts)
   */
  confirmPayment: async (debtId) => {
    const response = await axiosPrivate.post(
      `/api/expenses/debts/${debtId}/confirm`,
    );
    return response.data;
  },

  /**
   * Reject payment (creditor rejects)
   */
  rejectPayment: async (debtId) => {
    const response = await axiosPrivate.post(
      `/api/expenses/debts/${debtId}/reject`,
    );
    return response.data;
  },
};
